import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrModificationMode.ts
var t = () => e("modificationMode");
//#endregion
export { t as useTrModificationMode };
